import React from 'react';

import {Button, Col, DatePicker, Form, Input, Radio, Row, Select, Space, Switch, Typography} from 'antd';
import {KnowledgeQuestionType} from '../../hooks/apis/useKnowledgeBank';

const {Text, Title, Paragraph} = Typography;

export interface IKnowledgeBankEditForm {
  id?: number;
  name: string;
  type: KnowledgeQuestionType;
}

const KnowledgeBankEditForm = (props: {form?: IKnowledgeBankEditForm; isLoading: boolean; onFinish: (value: IKnowledgeBankEditForm) => any}) => {
  const [form] = Form.useForm();

  const defaultForm: IKnowledgeBankEditForm = {
    name: '',
    type: KnowledgeQuestionType.单选题,
  };

  React.useEffect(() => {
    form.setFieldsValue(props.form || defaultForm);
  }, [props.form]);

  return (
    <Form
      labelCol={{span: 6}}
      wrapperCol={{span: 14}}
      layout={'horizontal'}
      form={form}
      onFinish={value => {
        value.id = props.form?.id;
        props.onFinish(value as IKnowledgeBankEditForm);
      }}>
      <Form.Item label={'题库名称'} name={'name'} rules={[{required: true}]}>
        <Input size={'large'} placeholder="请输入题库名称" />
      </Form.Item>

      <Form.Item label={'类型'} name={'type'} rules={[{required: true}]}>
        <Radio.Group disabled={!!(props.form && props.form.id)}>
          <Radio value={KnowledgeQuestionType.单选题}>单选题</Radio>
          <Radio value={KnowledgeQuestionType.多选题}>多选题</Radio>
        </Radio.Group>
      </Form.Item>
      <Row>
        <Col span={6} />
        <Col>
          <Space>
            <Button size={'large'} type="primary" loading={props.isLoading} htmlType="submit" className="login-form-button">
              保存
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default KnowledgeBankEditForm;
